import { render, staticRenderFns } from "./PromotionalItems.vue?vue&type=template&id=f447c224&"
import script from "./PromotionalItems.vue?vue&type=script&lang=js&"
export * from "./PromotionalItems.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports